
import Vue, { PropType } from 'vue'
import Opz2Icon from './Opz2Icon.vue'
import Opz2Cards from './Opz2Cards.vue'
import Opz2Table from './Opz2Table.vue'
import { Report, Row, adminLabel, cnt, money, periodLabel } from './model'

/** Строки и итог — kpi_opz / kpi_opz_total функции как есть; нет поля — «—». */
export default Vue.extend({
    name: 'Opz2KpiPane',
    components: { Opz2Icon, Opz2Cards, Opz2Table },
    props: {
        report: { type: Object as PropType<Report>, required: true },
        emptyLabel: { type: String, default: 'Нет записей за период' },
    },
    data: () => ({
        columns: [
            { label: 'Администратор', key: 'name', width: 218 },
            { label: 'Визитов', key: 'visits_admin_cnt', cls: 'num', width: 99 },
            {
                label: 'ОПЗ без отмен',
                key: 'recorded_same_spec_active_admin_cnt',
                cls: 'num',
                cellCls: 'num value-wasabi',
                width: 132,
            },
            {
                label: 'Кросс-продаж без отмен',
                key: 'recorded_other_spec_active_admin_cnt',
                cls: 'num',
                cellCls: 'num value-teal',
                width: 176,
            },
            { label: 'Впервые без отмен', key: 'recorded_firstly_active_admin_cnt', cls: 'num', width: 120 },
            {
                label: 'Начислено',
                key: 'accrued_admin_sum',
                cls: 'num',
                cellCls: 'num value-indigo',
                width: 140,
                money: true,
            },
        ] as any[],
        cancelColumns: [
            { label: 'Администратор', key: 'name', width: 218 },
            { label: 'Отменено ОПЗ', key: 'recorded_same_spec_cancel_admin_cnt', cls: 'num' },
            { label: 'Отменено кросс-продаж', key: 'recorded_other_spec_cancel_admin_cnt', cls: 'num' },
            { label: 'Всего отмен', key: 'recorded_cancel_admin_cnt', cls: 'num' },
        ] as any[],
    }),
    computed: {
        rows(): Row[] {
            return this.report.kpi.rows.map(row => ({
                ...row,
                name: adminLabel(this.report, row.opz_creating_user_id),
            }))
        },
        total(): Row {
            return this.report.kpi.total
        },
        period(): string {
            return periodLabel(this.report.period.from, this.report.period.to)
        },
        cards(): any[] {
            const t = this.total
            return [
                {
                    label: 'Начислено премий',
                    value: money(t.accrued_admin_sum),
                    note: 'По активным правилам KPI',
                    color: 'indigo',
                },
                {
                    label: 'ОПЗ без отмен',
                    value: cnt(t.recorded_same_spec_active_admin_cnt),
                    note: 'То же направление',
                    color: 'wasabi',
                },
                {
                    label: 'Кросс-продаж без отмен',
                    value: cnt(t.recorded_other_spec_active_admin_cnt),
                    note: 'Другая категория',
                    color: 'teal',
                },
                {
                    label: 'Впервые без отмен',
                    value: cnt(t.recorded_firstly_active_admin_cnt),
                    note: 'Клиента записали на категорию услуг, на которой он ещё не был',
                    color: 'amber',
                },
            ]
        },
    },
    methods: { cnt, money },
})
